import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Label from '../../../../components/label/Label';
import RichGrid from '../../../../components/richgrid/RichGrid';
import styles from './SubmitReconciliationListing.styles';
import { componentKey, setOpenReconciliationPaymentDrawer, setScheduleReconciliationDate, updatePaginationState, setShowStateWitheldPaymentFrequencyPopup } from './SubmitReconciliationListingSlice';
import { componentKey as reconciliationComponentKey } from '../ReconciliationSlice';
import useGarbageCollector from '../../../../../libs/garbagecollector/garbageCollectorHooks';
import { ROW_SELECTION_OPTIONS } from '../../../../components/richgrid/constants';
import { FORM_SECTION_ROUTES } from '../../constants';
import { getReconFrequencyPopUpOption, getReconciliationAmount, getSubmitReconciliationGridRecords, viewReconciliationPDF } from './SubmitReconciliationListingSaga';
import Heading from '../../../../components/heading/Heading';
import { HEADING } from '../../../../components/heading/constants/constants';
import Button from '../../../../components/button/Button';
import { BUTTON_TYPE } from '../../../../components/button/constants';
import { addNotifications } from '../../../toaster/ToasterPortalSlice';
import { TOASTER_VARIANT } from '../../../../components/toast/constants';
import { FREQUENCY_POPUP_HEADER, RECONCILIATION_FORM_STATUS, RECONCILIATION_LOADING_STATES, RECONCILIATION_LOADING_STATES_MESSAGE_MAP, SELECT_PAYMENT_FREQUENCY } from '../constants';
import PaymentDrawer from '../../../components/paymentdrawer/PaymentDrawer';
import { PLACE_OF_ORIGIN_FOR_PAYMENT } from '../../../components/paymentdrawer/constants';
import ReconciliationDataService from '../../../../../services/ReconciliationDataService';
import CalendarInputWDateFormat from '../../../../components/input/calendarinput/CalendarInputWDateFormat';
import DateUtils from '../../../../../libs/utility/DateUtils';
import Popup from '../../../../components/popup/Popup';
import RadioInput from '../../../../components/input/radioinput/RadioInput';
import useTxNavigate from '../../../../../libs/txnavigate/TxNavigateHook';
import ReconciliationFormSubmitPopup from '../../../components/reconciliationformsubmitpopup/ReconciliationFormSubmitPopup';
import commonStyles from '../../FormSection.styles'
import Loadable from '../../../../components/loadable/Loadable';

export default function SubmitReconciliationListing() {
    useGarbageCollector(componentKey);

    const { loadingState, listRecords, paginationState, openReconciliationPaymentDrawer, reconciliationAmount, scheduleReconciliationDate, showStateWitheldPaymentFrequencyPopup, stateWitheldPaymentFrequency } = useSelector(state => state[componentKey]);
    const { reconciliationSelectedFormRecords, reconciliationSelectedPayer, reconciliationSelectedTaxYear, reconciliationSelectedState, isReconciliationFormSelectedFromListingPage, selectedReferenceNumbersAndFormNames } = useSelector(state => state[reconciliationComponentKey]);
    const [isSubmitReconilaitionPopupOpen, setIsSubmitReconilaitionPopupOpen] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [selectedFrequency, setSelectedFrequency] = useState("");

    const navigate = useTxNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getReconFrequencyPopUpOption());
    }, []);

    useEffect(() => {
        if (reconciliationSelectedFormRecords.length < 1 && !isReconciliationFormSelectedFromListingPage) {
            navigate(`/${FORM_SECTION_ROUTES.FORMS}/${FORM_SECTION_ROUTES.RECONCILIATION}/${FORM_SECTION_ROUTES.LISTING}`);
        } else {
            reconciliationGridRecords(reconciliationSelectedPayer, paginationState?.pageSize, paginationState?.pageNumber, reconciliationSelectedTaxYear, reconciliationSelectedState, reconciliationSelectedFormRecords, selectedReferenceNumbersAndFormNames);
        }
    }, [reconciliationSelectedFormRecords, isReconciliationFormSelectedFromListingPage]);

    const reconciliationGridRecords = (reconciliationSelectedPayer, pageSize, pageNumber, reconciliationSelectedTaxYear, reconciliationSelectedState, reconciliationSelectedFormRecords, selectedReferenceNumbersAndFormNames) => {
        dispatch(getSubmitReconciliationGridRecords({
            Payerid: reconciliationSelectedPayer?.PayerDetailId,
            PageSize: pageSize,
            PageNumber: pageNumber,
            taxYear: reconciliationSelectedTaxYear?.value,
            state: reconciliationSelectedState?.value,
            formName: reconciliationSelectedFormRecords[0]?.FormName,
            referenceNumber: selectedReferenceNumbersAndFormNames?.selectedReferenceNumbers,
        }));
    }

    const listingColumns = [
        {
            field: "state",
            header: <Label>State</Label>,
            renderLogic: (row, idx) => <span>{row?.State}</span>
        },
        {
            field: "status",
            header: <Label>Status</Label>,
            renderLogic: (row, idx) => <span>{row?.Status}</span>
        },
        {
            field: "reconciliationForm",
            header: <Label>Reconciliation Form</Label>,
            renderLogic: (row, idx) => <span>{row?.ReconciliationFormName}</span>
        },
        {
            field: "action",
            header: <Label>Action</Label>,
            renderLogic: (row, idx) => <span style={styles.actionButtonsDiv}>
                <Button
                    style={(row?.Status === RECONCILIATION_FORM_STATUS.COMPLETED) ? styles.btnColorGreen : styles.btnColorRed} type={BUTTON_TYPE.PRIMARY}
                    onClickCb={() => handleFileReconciliationBtnClk(row)}>
                    {(row?.Status === RECONCILIATION_FORM_STATUS.COMPLETED) ? "Edit" : "File"} Reconciliation Form
                </Button>
                <Button type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER} onClickCb={() => handlePDFBtnClick(row)}>PDF</Button>
            </span>
        }
    ];

    const handlePDFBtnClick = (rowData) => {
        if (rowData?.Status === RECONCILIATION_FORM_STATUS.INCOMPLETE) {
            dispatch(addNotifications({
                heading: "Attention",
                message: `Please File Reconciliation Form for the State ${rowData?.State} to view PDF`,
                variant: TOASTER_VARIANT.WARNING
            }));
        } else {
            dispatch(viewReconciliationPDF({
                formId: rowData?.FormRecordId,
                state: rowData?.State,
                formName: rowData?.FormName,
            }));
        }
    }

    const handleFileReconciliationBtnClk = (row) => {
        setSelectedRow(row);
        if(stateWitheldPaymentFrequency[row?.ReconciliationFormName]) {
            dispatch(setShowStateWitheldPaymentFrequencyPopup(true));
        } else {
            setIsSubmitReconilaitionPopupOpen(true);
        }
    }

    const proceedNxtToReconciliationPayment = () => {
        dispatch(getReconciliationAmount({
            payerId: reconciliationSelectedPayer?.PayerDetailId,
            referenceIds: selectedReferenceNumbersAndFormNames?.selectedReferenceNumbers,
            formName: selectedReferenceNumbersAndFormNames?.selectedFormNames,
            state: reconciliationSelectedState?.value,
            reconciliationFormId: listRecords[0]?.FormRecordId,
            taxYear: reconciliationSelectedTaxYear?.value,
        }));
    }

    return <>
        <Heading type={HEADING.H1}>Submit State Reconciliation</Heading>
        <div style={styles.container}>
            <span style={styles.selectedLabelsStyle}><Heading type={HEADING.H3} customStyle={styles.headingCustomStyles}>Payer Name: </Heading><span>{reconciliationSelectedPayer?.FullName}</span></span>
            <span style={styles.selectedLabelsStyle}><Heading type={HEADING.H3} customStyle={styles.headingCustomStyles}>Tax Year: </Heading><span>{reconciliationSelectedTaxYear?.value}</span></span>
            <div style={styles.scheduleDateDiv}>
                <CalendarInputWDateFormat
                    label={"Scheduled Date:"}
                    value={scheduleReconciliationDate}
                    inputClassName="w-100"
                    onChangeCb={(e) => dispatch(setScheduleReconciliationDate(e))}
                    allowOnlyFutureDate={true}
                />
            </div>
            <Loadable loadingStates={[RECONCILIATION_LOADING_STATES.GRID_LOADING]} messageMap={RECONCILIATION_LOADING_STATES_MESSAGE_MAP} currentState={loadingState.state} isNewLoadable={true}>
                <RichGrid
                    data={listRecords}
                    columns={listingColumns}
                    selectable={false}
                    extractRowKey={(row) => row.state}
                    onSelectionChangeCallBack={(selectedData) => { }}
                    selectedRows={{}}
                    paginationProps={{
                        skip: paginationState.skip,
                        take: paginationState.pageSize,
                        takeOptions: ROW_SELECTION_OPTIONS,
                        onChangeTakeCb: (newTake) => {
                            dispatch(updatePaginationState({ pageSize: newTake, pageNumber: 1, skip: 0 }));
                            reconciliationGridRecords(reconciliationSelectedPayer, newTake, paginationState?.pageNumber, reconciliationSelectedTaxYear, reconciliationSelectedState, reconciliationSelectedFormRecords, selectedReferenceNumbersAndFormNames);
                        },
                        total: paginationState.total,
                        onChange: (take, skip) => {
                            dispatch(updatePaginationState({ pageSize: take, skip: skip, pageNumber: Math.ceil((take + skip) / take) }));
                            reconciliationGridRecords(reconciliationSelectedPayer, take, Math.ceil((take + skip) / take), reconciliationSelectedTaxYear, reconciliationSelectedState, reconciliationSelectedFormRecords, selectedReferenceNumbersAndFormNames);
                        },
                    }}
                />
                {
                    (listRecords[0]?.Status === RECONCILIATION_FORM_STATUS.COMPLETED) ?
                        <div style={styles.proceedToPaymentBtnDiv}>
                            <Button type={BUTTON_TYPE.PRIMARY} onClickCb={proceedNxtToReconciliationPayment}>Next</Button>
                        </div>
                        : null
                }
            </Loadable>
        </div>
        { isSubmitReconilaitionPopupOpen && <ReconciliationFormSubmitPopup
                isPopupOpen={isSubmitReconilaitionPopupOpen}
                title={`Form ${listRecords[0]?.ReconciliationFormName}`}
                formId={listRecords[0]?.ReconciliationFormName}
                handlePopupClose={() => setIsSubmitReconilaitionPopupOpen(false)}
                onFinalSubmitCb={() => reconciliationGridRecords(reconciliationSelectedPayer, paginationState?.pageSize, paginationState?.pageNumber, reconciliationSelectedTaxYear, reconciliationSelectedState, reconciliationSelectedFormRecords, selectedReferenceNumbersAndFormNames)}
                isEditModeOn={(selectedRow?.FormRecordId && selectedRow?.FormRecordId != "0") ? true : false}
                taxYear={reconciliationSelectedTaxYear?.value}
                reconciliationPayerId={reconciliationSelectedPayer?.PayerDetailId}
                reconciliationState={reconciliationSelectedState?.value}
                formRecordId={(selectedRow?.FormRecordId && selectedRow?.FormRecordId != "0") ? selectedRow?.FormRecordId : 0}
                referenceId={selectedReferenceNumbersAndFormNames?.selectedReferenceNumbers}
                quarter={selectedFrequency}
                scheduleReconciliationDate={(scheduleReconciliationDate !== "") ? scheduleReconciliationDate : DateUtils.dateFormatter(new Date(), 'YYYY-MM-DD')}
                stateFormName={selectedRow.FormName}
            />
        }
        
        {openReconciliationPaymentDrawer &&
            <PaymentDrawer
                isOpen={openReconciliationPaymentDrawer}
                onCloseCb={() => dispatch(setOpenReconciliationPaymentDrawer(false))}
                fees={{
                    OnlySeparateStatefiling: "false",
                    TotalFilingFee: reconciliationAmount.toString(),
                    FilingFee: reconciliationAmount.toString(),
                    USPSFee: "0",
                    TINMatchFee: "0",
                    StateFee: "0",
                    TINCount: "0",
                    StateFilingCount: "0",
                    USPSCount: "0",
                    FormCount: "0",
                }}
                filingFeeLabel={`Reconciliation Filing Fee`}
                calculatePrepaySalesTax={true}
                paymentServiceFunctionCb={ReconciliationDataService.submitReconciliationPayment}
                onPaymentSuccessCb={() => { navigate(`/`) }}
                placeOfOriginforpayment={PLACE_OF_ORIGIN_FOR_PAYMENT.RECONCILIATION_PAYMENT}
                paymentServiceFunctionExtraParams={{
                    payerId: reconciliationSelectedPayer?.PayerDetailId.toString(),
                }}
            />
        }
        <Popup
            title={FREQUENCY_POPUP_HEADER}
            showClose={false}
            isPopupOpen={showStateWitheldPaymentFrequencyPopup}
        >
            <div style={commonStyles.frequencyPopupBody}>
                <div style={commonStyles.frequencyPopupPaddingTen}>
                    {stateWitheldPaymentFrequency[selectedRow?.ReconciliationFormName]?.map(frequency => 
                            <RadioInput label={{  suffixLabel: frequency.label }} value={frequency.id} checked={ selectedFrequency === frequency.id } onChangeCb={(e) => setSelectedFrequency(frequency.id)} />
                        )
                    }
                </div>
                <div style={commonStyles.frequencyPopupFooter}>
                    <Button type={BUTTON_TYPE.PRIMARY} onClickCb={() => {
                        if(selectedFrequency !== "") {
                            setIsSubmitReconilaitionPopupOpen(true);
                            dispatch(setShowStateWitheldPaymentFrequencyPopup(false))
                        } else {
                            dispatch(addNotifications({
                                heading: "Error",
                                message: SELECT_PAYMENT_FREQUENCY,
                                variant: TOASTER_VARIANT.WARNING
                            }))
                        }
                        }}>Confirm</Button>
                    <Button type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER} onClickCb={() => {
                        setSelectedFrequency("");
                        dispatch(setShowStateWitheldPaymentFrequencyPopup(false));
                        }} >Cancel</Button>
                </div>
            </div>
        </Popup>
    </>
}